import { createSelector } from 'reselect';

import type { Moment } from 'moment';

import { RequestState } from '../reducers/utils/state-manager';

export type FeatureGate = {
  gateName: string;
  isEnabled: boolean;
  ttl: Moment | string;
};

type FeatureGateDictionary = { [usernameFlag: string]: FeatureGate };
type FeatureGateStateDictionary = { [usernameFlag: string]: RequestState };

export type FeatureGateState = {
  featureGatesByUsernameFlag: FeatureGateDictionary;
  featureGatesStateByUsernameFlag: FeatureGateStateDictionary;
};

type State = { featureGates: FeatureGateState };

const featureGatesByUsernameFlagSelector = (state: State) =>
  state.featureGates.featureGatesByUsernameFlag;
export const featureGatesForUsername = createSelector(
  [featureGatesByUsernameFlagSelector, (_state: State, username: string) => username],
  (featureGatesByUsernameFlag, username) => {
    if (!featureGatesByUsernameFlag) {
      return [];
    }

    return Object.entries(featureGatesByUsernameFlag).reduce((acc, [key, val]) => {
      if (key.split('-')[0] === username) {
        acc.push(val);
      }
      return acc;
    }, [] as Array<FeatureGate>);
  },
);

export const featureGatesForUsernameFlag = createSelector(
  [
    featureGatesByUsernameFlagSelector,
    (_state: State, username: string) => username,
    (_state: State, _username: string, flag: string) => flag,
  ],
  (featureGatesByUsernameFlag, username, gateName) =>
    featureGatesByUsernameFlag?.[`${username}-${gateName}`] || null,
);

const featureGatesStateByUsernameFlagSelector = (state: State) =>
  state.featureGates.featureGatesStateByUsernameFlag;
export const featureGatesStateForUsernameFlag = createSelector(
  [
    featureGatesStateByUsernameFlagSelector,
    (_state: State, username: string) => username,
    (_state: State, _username: string, gateName: string) => gateName,
  ],
  (featureGatesStateByUsernameFlag, username, gateName) =>
    featureGatesStateByUsernameFlag?.[`${username}-${gateName}`] || {},
);
